
import { useState, useCallback } from "react";
import { AdminLink, OwnerLink } from "@/components/layout/sidebar/types";
import { AccessControl } from "@/hooks/sidebar/types";

export const useMenuVisibility = (
  accessControls: AccessControl[] | undefined,
  links: (AdminLink | OwnerLink)[],
  refetch: () => void
) => {
  const [visibleMenuItems, setVisibleMenuItems] = useState<string[]>(['dashboard']);
  const [selectedMenuItem, setSelectedMenuItem] = useState<string | null>(null);
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const toggleMenuItemVisibility = useCallback((name: string, feature?: string) => {
    if (!feature) return;
    
    setVisibleMenuItems(prev => 
      prev.includes(feature)
        ? prev.filter(item => item !== feature)
        : [...prev, feature]
    );
  }, []);

  return {
    visibleMenuItems,
    selectedMenuItem,
    isDialogOpen,
    setIsDialogOpen,
    setSelectedMenuItem,
    toggleMenuItemVisibility,
    setVisibleMenuItems,
  };
};
